import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import CopyToClipboard from 'react-copy-to-clipboard';
import StyledTextField from '../common/StyledTextField';
import { postRequest } from '../../requestUtils';
import confirmationSentImg from '../../../assets/images/confirmation_sent.png';
import { analyticsTrack } from '../../analyticsUtils';
import './ConsultantCard.scss';

const renderTitleAndDepartment = (title, department, mediumWeightClass) => (
  <div className={`body-text-2 ${mediumWeightClass && 'medium-weight'}`}>
    {title}
    <span className="normal-weight">{department && ` - ${department}`}</span>
  </div>
);

const renderSkills = (name, skills, highlightValue) => {
  if (skills && skills.length > 0) {
    return (
      <div className="skill">
        <div className="body-text-2 medium-weight skill-name">{name}</div>
        {skills.map((skill) => (
          <span key={skill} className={`badge small ${skill === highlightValue ? 'purple-base' : 'blue-light'}`}>{skill}</span>
        ))}
      </div>
    );
  }
  return null;
};

class ConsultantCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal || false,
      showInfoSent: false,
      connected: false,
      proposalRequested: props.proposalRequested || false,
      email: props.email || '',
      validForm: false,
      copied: false,
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.connect = this.connect.bind(this);
    this.requestProposal = this.requestProposal.bind(this);
    this.openForm = this.openForm.bind(this);
    this.onCopy = this.onCopy.bind(this);
  }

  onCopy() {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 1000);
  }

  open() {
    const { featuredProfile, location } = this.props;
    analyticsTrack('Clicked on View Profile', {
      location,
      resource_id: featuredProfile.resource_id,
    });
    this.setState({ showModal: true });
  }

  close() {
    this.setState({ showModal: false, showInfoSent: false });
  }

  handleInputChange(event) {
    const { target } = event;
    this.setState({ validForm: target.validity.valid, [target.name]: target.value });
  }

  connect() {
    const { connectUrl, csrfToken, featuredProfile } = this.props;
    const {
      name, email, company, validForm,
    } = this.state;
    if (this.props.email || validForm) {
      postRequest(
        connectUrl,
        { employer: { name, email, company_name: company } },
        csrfToken,
      ).then(() => {
        this.setState({ connected: true });
        analyticsTrack('Clicked on Get Connected', {
          location: 'Featured Consultants',
          resource_id: featuredProfile.resource_id,
        });
      });
    }
  }

  requestProposal() {
    const { requestProposalUrl, csrfToken, featuredProfile } = this.props;
    postRequest(
      requestProposalUrl,
      { consultant_profile_id: featuredProfile.id },
      csrfToken,
    ).then(() => {
      this.setState({ proposalRequested: true, showInfoSent: true });
      analyticsTrack('Clicked on Request Proposal', {
        location: 'Project Show',
        resource_id: featuredProfile.resource_id,
      });
    });
  }

  openForm() {
    this.typeformEmbed.typeform.open();
  }

  renderForm(featuredProfile) {
    const { email } = this.props;
    return (
      <div>
        <div className="header">
          <h2 className="mb-8">
            Get connected with
            {featuredProfile.name}
          </h2>
          <p>
            Fill out the form below and Clora will be in touch with you shortly to facilitate an
            introduction with
            {' '}
            {featuredProfile.name}
          </p>
        </div>
        <form id="connect-with-featured-profile" onSubmit={(event) => event.preventDefault()}>
          <StyledTextField
            className="form-control fs-hide validate"
            name="email"
            label="Work Email"
            type="email"
            margin="normal"
            defaultValue={email}
            onChange={this.handleInputChange}
            required
            autoFocus
          />
          <div className="actions mt-3">
            <input
              type="submit"
              name="commit"
              id="get-connected"
              className="btn btn-primary"
              value="Get Connected"
              onClick={this.connect}
            />
          </div>
        </form>
      </div>
    );
  }

  renderOverview(includeLinkButton = false, shortened = false) {
    const { featuredProfile, shareLink } = this.props;
    const { copied, proposalRequested, showModal } = this.state;
    return (
      <div>
        <div className="header">
          {includeLinkButton
            && (
            <div className="pull-right">
              { copied
                ? <i className="fa fa-check" />
                : (
                  <CopyToClipboard
                    text={shareLink}
                    onCopy={this.onCopy}
                  >
                    <a className="btn-secondary">
                      <i className="fa fa-link copy-link" />
                    </a>
                  </CopyToClipboard>
                )}
            </div>
            )}
          <div className="g-row">
            <div className={!shortened && 'g-flex-8'}>
              { proposalRequested && !showModal && shortened
                && (
                <div className="body-text-3 regular demibold green-label mb-8">
                  Proposal Requested
                </div>
                )}
              { shortened
                && (
                <div className="body-text-2 bold d-inline-block mr-8 mb-4 transform-name">
                  {featuredProfile.name}
                </div>
                )}
              { !shortened
                && <h2 className="d-inline-block mr-8 mb-4 transform-name">{featuredProfile.name}</h2>}
              {featuredProfile.years_of_experience
                && (
                <span className="body-text-2 medium-weight">
                  |
                  {' '}
                  {featuredProfile.years_of_experience}
                  {' '}
                  years of experience
                </span>
                )}
            </div>
            <div className={!shortened && 'g-flex-4'}>
              { proposalRequested && showModal && !shortened
              && (
              <div className="body-text-3 regular demibold green-label mb-8">
                Proposal Requested
              </div>
              )}
            </div>
          </div>
          {featuredProfile.city
            && (
            <div className="body-text-2 muted-gray-text">
              <i className="fa fa-map-marker-alt mr-5" />
              <span className="d-inline-block">{featuredProfile.city}</span>
            </div>
            )}
        </div>

        <div className="experiences">
          {featuredProfile.recent_titles
            && (
            <div className="recent-titles mb-12">
              <div className="body-text-2 medium-weight mb-4 green">Recent Titles</div>
              {featuredProfile.recent_titles[0] && renderTitleAndDepartment(
                featuredProfile.recent_titles[0].title,
                featuredProfile.recent_titles[0].department,
                !shortened,
              )}
              <div className="body-text-2 medium-weight">
                {featuredProfile.recent_titles[1] && renderTitleAndDepartment(
                  featuredProfile.recent_titles[1].title,
                  featuredProfile.recent_titles[1].department,
                  !shortened,
                )}
              </div>
            </div>
            )}

          { !shortened && featuredProfile.previous_companies
            && (
            <div className="recent-companies">
              <div className="body-text-2 medium-weight mb-4 green">Previous Companies</div>
              <div className="body-text-2">
                {featuredProfile.previous_companies[0]}
              </div>
              <div className="body-text-2">
                {featuredProfile.previous_companies[1]}
              </div>
            </div>
            )}
        </div>
      </div>
    );
  }

  renderInfoSent() {
    const { featuredProfile, email } = this.props;
    const { connected, proposalRequested } = this.state;
    return (
      <div className="information-sent">
        <img src={confirmationSentImg} className="confirmation-sent" alt="confirmation sent" />
        { connected
          && (
          <h2 className="mb-4">
            {email ? 'Clora will reach out to you shortly!' : 'Your information was sent!'}
          </h2>
          )}
        { proposalRequested
          && (
          <h2 className="mb-4">
            You requested a proposal from
            {' '}
            {featuredProfile.name}
          </h2>
          )}
        { connected
          && (
          <div>
            <p className="body-text-2">
              {email
                ? `Clora will be in touch with you shortly to facilitate an introduction with ${featuredProfile.name}` : 'Clora will reach out to you shortly.'}
            </p>
            <button className="btn btn-primary leave-feedback" onClick={() => this.openForm()}>
              Leave Feedback
            </button>
          </div>
          )}
        { proposalRequested
          && (
          <p className="body-text-2">
            Clora will contact
            {' '}
            {featuredProfile.name}
            and invite them to fill out a proposal for your project.
          </p>
          )}
      </div>
    );
  }

  renderModal() {
    const {
      featuredProfile, email, isRep, filters, location,
    } = this.props;
    const { connected, showInfoSent, proposalRequested } = this.state;
    const onProjectShow = location === 'Project Show';

    if (email) {
      if (connected || showInfoSent) {
        return ([
          <Modal.Header closeButton />,
          <Modal.Body>
            {this.renderInfoSent()}
          </Modal.Body>,
        ]);
      }
      return ([
        <Modal.Header closeButton />,
        <Modal.Body className="consultant-details-modal-body">
          <div className="consultant-details white-background">
            {this.renderOverview(isRep, false)}

            <div className="tags">
              {renderSkills('Functional Areas', featuredProfile.area_of_expertises, filters.aoe)}
              {renderSkills('Therapeutic Areas', featuredProfile.therapeutic_areas, filters.ta)}
              {renderSkills('Treatment Modalities', featuredProfile.therapies, filters.pt)}
            </div>

            <div className="action mt-4 text-center">
              { onProjectShow && !proposalRequested
                && (
                <button
                  id=""
                  className="btn btn-primary"
                  onClick={this.requestProposal}
                >
                  Request Proposal
                </button>
                )}
              { !onProjectShow
                && (
                <button
                  id="get-connected"
                  className="btn btn-primary"
                  onClick={this.connect}
                >
                  Get Connected
                </button>
                )}
            </div>
          </div>
        </Modal.Body>,
      ]);
    }
    return (
      <Modal.Body>
        <div className="g-row">
          <div className="g-flex-7 consultant-details">
            {this.renderOverview(false, false)}

            <div className="tags">
              {renderSkills('Functional Areas', featuredProfile.area_of_expertises, filters.aoe)}
              {renderSkills('Therapeutic Areas', featuredProfile.therapeutic_areas, filters.ta)}
              {renderSkills('Treatment Modalities', featuredProfile.therapies, filters.pt)}
            </div>
          </div>
          <div className="g-flex-5 interest-form">
            <div
              onClick={this.close}
              role="button"
              tabIndex={0}
              className="close-modal"
            >
              <i className="fa fa-times fa-lg" />
            </div>
            {connected ? this.renderInfoSent() : this.renderForm(featuredProfile)}
          </div>
        </div>
      </Modal.Body>
    );
  }

  render() {
    const {
      location, featuredProfile, email, filters, isRep, truncated,
    } = this.props;
    const onProjectShow = location === 'Project Show';
    return ([
      <div
        className="consultant-card"
        onMouseOver={this.handleMouseOver}
        onFocus={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.open}
        role="button"
        tabIndex={0}
      >
        { !onProjectShow
        && (
        <ReactTypeformEmbed
          popup
          autoOpen={false}
          mode="drawer_right"
          url="https://clora.typeform.com/to/H7h7zx"
          ref={(tf) => {
            this.typeformEmbed = tf;
          }}
        />
        )}
        <div className="consultant-info">
          {this.renderOverview(isRep, truncated)}

          { !truncated
            && (
            <div className="tags">
              {renderSkills('', featuredProfile.area_of_expertises.slice(0, 3), filters.aoe)}
            </div>
            )}
        </div>

        <div className="actions">
          <button
            className={onProjectShow ? 'btn btn-secondary' : 'btn btn-primary'}
            onClick={this.open}
          >
            { onProjectShow ? 'View more' : 'View Profile' }
          </button>
        </div>
      </div>,
      <Modal
        show={this.state.showModal}
        onHide={this.close}
        dialogClassName={`style-guide ${email && 'modal-600w'}`}
      >
        {this.renderModal()}
      </Modal>,
    ]);
  }
}

ConsultantCard.propTypes = {
  location: PropTypes.string.isRequired,
  featuredProfile: PropTypes.shape({}).isRequired,
  connectUrl: PropTypes.string.isRequired,
  requestProposalUrl: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  email: PropTypes.string,
  shareLink: PropTypes.string.isRequired,
  showModal: PropTypes.bool,
  proposalRequested: PropTypes.bool,
  isRep: PropTypes.bool,
  filters: PropTypes.shape({}),
  truncated: PropTypes.bool,
};

ConsultantCard.defaultProps = {
  showModal: false,
  proposalRequested: false,
  filters: {},
  truncated: false,
};

export default ConsultantCard;
